import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ProductActivationWrapper } from "../../components/ProductActivationWrapper/ProductActivationWrapper";
import { useFeatureFlags } from "../../query/hooks/useFeatureFlags";
import {
  PATH_BENEFITS_AXIS_INSURANCE,
  PATH_BENEFITS_AXIS_INSURANCE_DETAILS,
  PATH_BENEFITS_ENROLL,
  PATH_BENEFITS_INSURANCE,
  PATH_BENEFITS_INSURANCE_ENROLL,
  PATH_BENEFITS_PERKS,
  PATH_BENEFITS_MERIDIO_EXPLORE_PLANS,
  PATH_BENEFITS_MERIDIO_ENROLL
} from "./paths";
import { RouteAxisInsurance } from "./routes/RouteAxisInsurance";
import { RouteAxisInsuranceDetails } from "./routes/RouteAxisInsuranceDetails";
import { RouteBenefitsInsuranceIndex } from "./routes/RouteBenefitsInsurance/RouteBenefitsInsuranceIndex";
import { RouteEnroll } from "./routes/RouteEnroll";
import { RouteEnrollInsurance } from "./routes/RouteEnrollInsurance";
import { RouteBenefitsPremiumPerksIndex } from "./routes/RouteMyBenefits/RouteBenefitsPremiumPerksIndex";
import { RouteExploreMeridioPlans } from "./routes/RouteExploreMeridioPlans";
import { RouteEnrollMeridio } from "./routes/RouteEnrollMeridio";

export const BenefitsRoutes: React.FC = () => {
  const featureFlags = useFeatureFlags();

  return (
    <ProductActivationWrapper>
      <Switch>
        {featureFlags.data?.meridioInAppEnrollment && (
          <Route
            path={PATH_BENEFITS_MERIDIO_EXPLORE_PLANS}
            exact
            component={RouteExploreMeridioPlans}
          />
        )}
        {featureFlags.data?.meridioInAppEnrollment && (
          <Route
            path={PATH_BENEFITS_MERIDIO_ENROLL}
            component={RouteEnrollMeridio}
          />
        )}

        <Route
          path={PATH_BENEFITS_INSURANCE}
          component={RouteBenefitsInsuranceIndex}
        />

        <Route
          path={PATH_BENEFITS_AXIS_INSURANCE}
          component={RouteAxisInsurance}
          exact
        />

        <Route
          path={PATH_BENEFITS_AXIS_INSURANCE_DETAILS}
          exact
          component={RouteAxisInsuranceDetails}
        />

        <Route
          path={PATH_BENEFITS_PERKS}
          component={RouteBenefitsPremiumPerksIndex}
        />

        <Route path={PATH_BENEFITS_ENROLL} component={RouteEnroll} />

        <Route
          component={RouteEnrollInsurance}
          path={PATH_BENEFITS_INSURANCE_ENROLL}
        />

        <Redirect
          from="*"
          to={
            featureFlags.data?.customBenefitsLloydCapital
              ? PATH_BENEFITS_AXIS_INSURANCE
              : PATH_BENEFITS_PERKS
          }
        />
      </Switch>
    </ProductActivationWrapper>
  );
};
export { PATH_BENEFITS_ENROLL } from "./paths";
